import ProducerTable from "../../components/Producer/ProducerTable"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Producer() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn, userInfo } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn, userInfo]);

  return (
    <div className="">
      <ProducerTable />
    </div>
  );
}

export default Producer;
